/* Gallery inline videos: force-mute (so muted-autoplay is allowed) and play only while in view.
 * On variant (colour) change product-info.js re-renders the gallery and pauses the video; we listen
 * for that change and restart the clip from 0, so switching colour replays it from the beginning.
 * Respects a manual pause (controls) during normal scrolling — once the user pauses, we don't
 * auto-resume on scroll (but an explicit variant change does restart it). */
(function () {
  console.log('[gallery-video] build=2026-06-17-v4-variant-restart');

  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            if (!v._userPaused) v.play().catch(function () {});
          } else {
            v._byObserver = true;
            v.pause();
            v._byObserver = false;
          }
        });
      }, { threshold: 0.25 })
    : null;

  function setup(v) {
    if (v._hgInit) return;        // each element only wired once
    v._hgInit = true;
    v.muted = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    v.addEventListener('pause', function () { if (!v._byObserver) v._userPaused = true; });
    v.addEventListener('play', function () { v._userPaused = false; });
    if (io) {
      io.observe(v);
    } else {
      v.play().catch(function () {});
    }
  }

  function galleryVideos() {
    return document.querySelectorAll('.product__media-list .product-media-container.media-type-video video');
  }

  function scan() {
    galleryVideos().forEach(setup);
  }

  function inView(v) {
    var b = v.getBoundingClientRect();
    return b.bottom > 0 && b.top < (window.innerHeight || document.documentElement.clientHeight);
  }

  // Variant change: product-info.js keeps the same <video> element but pauses it. Rewind to 0 so the
  // clip replays from the start; play now if it's on screen, otherwise the observer plays it on scroll.
  function restart() {
    galleryVideos().forEach(function (v) {
      setup(v);
      v._userPaused = false;
      try { v.currentTime = 0; } catch (_) {}
      v.muted = true;
      if (inView(v)) v.play().catch(function () {});
    });
  }

  // Variant change is async: clicking a colour fires the radio `change`, then product-info.js fetches
  // and re-renders the gallery (~hundreds of ms later), pausing the video. The theme's global pub/sub
  // is a decoupled no-op here, so instead we open a short "restart window" on the radio change and
  // rewind the video whenever the gallery actually re-renders during that window.
  var restartUntil = 0;

  function onVariantInput(e) {
    var t = e.target;
    if (!t || (t.type !== 'radio' && t.tagName !== 'SELECT')) return;
    if (!t.closest('.product-form__input, variant-selects, variant-radios')) return;
    restartUntil = Date.now() + 2000; // re-render lands within ~2s of the click
    requestAnimationFrame(restart);   // in case the element persists and is simply paused
  }

  function init() {
    scan();
    document.addEventListener('change', onVariantInput, true);
    document.addEventListener('variant:change', function () { requestAnimationFrame(restart); });

    // One observer drives both: pick up freshly-injected videos, and (inside the restart window)
    // rewind+play after a variant re-render. Debounced — the page mutates a lot (cart, etc.).
    var queued = false;
    var mo = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        scan();
        if (Date.now() < restartUntil) restart();
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
